import * as Yup from "yup";

const SysInfoSchema = Yup.object().shape({
  config_name: Yup.string().required("Please enter a title").strict().trim(),
  config_value: Yup.string().required("This is required"),
  status: Yup.string().oneOf(["active", "inactive"]).default("inactive"),
});

export default SysInfoSchema;
